import ConnectWiseConnectConfig from './connectwise/connect/config';
import ConnectWiseControlConfig from './connectwise/control/config';
import AutoTaskConfig from './autotask/config';
import KaseyaConfig from './kaseya/config';

export default [
    ConnectWiseConnectConfig,
    ConnectWiseControlConfig,
    KaseyaConfig,
    AutoTaskConfig,
];
